import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import TableCell from '@mui/material/TableCell';

const SortableTableCell = ({ index, label, sortIndex, sortOrder, hover, setSort, setHover }) => {
    return (
        <TableCell
            align="left"
            className="sortColumn"
            onClick={() => setSort(index)}
            onMouseOver={() => setHover(index)}
            onMouseOut={() => setHover(-1)}
        >
            <span>{label}</span>
            {sortIndex === index && sortOrder === 'asc' && (
                <span><ExpandMoreIcon /></span>
            )}
            {sortIndex === index && sortOrder === 'desc' && (
                <span><ExpandLessIcon /></span>
            )}
            {hover === index && sortIndex !== index && (
                <span><ExpandMoreIcon className="gray-icon" /></span>
            )}
        </TableCell>
    );
};

export default SortableTableCell;
